<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-people">
		  <Icon class="iconfont icon-fangwenliang" style="font-size:48px;"></Icon>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            访问数量
          </div>
          <count-to :start-val="0" :end-val="102400" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-message">
          <Icon class="iconfont icon-ziyuan9" style="font-size:48px;"></Icon>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            资源数量
          </div>
          <!-- <count-to :start-val="0" :end-val="resourceNumber" :duration="resourceNumber/3" class="card-panel-num" /> -->
          <count-to :start-val="0" :end-val="resourceNumber" :duration="100" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <Icon class="iconfont icon-yonghushuliang" style="font-size:48px;"></Icon>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            用户数量
          </div>
          <!-- <count-to :start-val="0" :end-val="userNumber" :duration="userNumber/3" class="card-panel-num" /> -->
          <count-to :start-val="0" :end-val="userNumber" :duration="100" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <Icon class="iconfont icon-xiangmushuliang" style="font-size:48px;"></Icon>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            项目数量
          </div>
          <!-- <count-to :start-val="0" :end-val="projectNumber" :duration="projectNumber/3" class="card-panel-num" /> -->
          <count-to :start-val="0" :end-val="projectNumber" :duration="100" class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'
import USERAPI from '@/api/user'
import RESOURCEAPI from '@/api/resource'
import PROJECTAPI from '@/api/project'
import {getInfo} from '@/utils/auth'
export default {
  data(){
	  return {
      groupId:'',
		  userNumber: NaN,
		  projectNumber: NaN,
		  resourceNumber: NaN,
		  userInfo:{}
	  }
  },
  components: {
    CountTo
  },
  methods: {
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    },
	//资源数量
  searchResourcePage(){
    let params = {
        "page": 1,
        "searchKey": "",
        "size": 1000
    }
    RESOURCEAPI.searchResourcePage(params).then(res=>{
      if(res.data.code==200){
        this.resourceNumber = res.data.data.totalElements;
      }
    })
  },
	//用户数量
  searchUserPage(){
    let params = {
      "groupId": this.groupId,
        "page": 1,
        "searchKey": "",
        "size": 1000
    }
    USERAPI.searchUserPage(params).then(res=>{
      if(res.data.code==200){
        this.userNumber = res.data.data.totalElements;
      }
    })
  },
	//项目数量
  searchProject(){
    PROJECTAPI.searchProject().then(res=>{
      if(res.data.code==200){
        this.projectNumber = res.data.data.length;
      }
    })
  }
  },
  created() {
  	let info = JSON.parse(getInfo());
    this.groupId = info.groupId;
    // this.searchUserPage();
    // this.searchProject();
    // this.searchResourcePage();
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/home/components/PanelGroup.vue